import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';
import { hasCrmTeamRole } from '@upme/contracts';
import { useAuth } from '../../../features/auth/auth-context';

export const Route = createFileRoute('/_authenticated/crm')({
  staticData: { breadcrumb: 'CRM' },
  component: CrmGuard,
});

function CrmGuard() {
  const { adminRoles } = useAuth();
  if (!hasCrmTeamRole(adminRoles)) {
    return <Navigate to="/" />;
  }
  return <Outlet />;
}
